import apiFetch from '../../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Bioseguridad/deleteBioSeguridad`, method: 'POST', body: values, token: token})
}
